import Messenger from '@/api/messenger'

const initLoad = commit => commit('changeLoading', { isLoading: true })

const onError = (commit, { error }) => {
  commit('changeLoading', { isLoading: false })
  throw error
}

export default {
  fetch: ({ commit }, { id }) => {
    initLoad(commit)
    return Messenger.fetchConversation({ id })
      .then(({ data }) => {
        commit('replaceItem', { item: data })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => onError(commit, { error }))
  },
  fetchPerPage: ({ commit }, { page, userId }) => {
    initLoad(commit)
    return Messenger.fetchConversations({ page, userId })
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: { page, userId }
        })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => onError(commit, { error }))
  },
  findConversationWith: ({ commit, rootGetters }, { user }) => {
    const otherUser = rootGetters['skiliko/session/currentUser'].chatable_id
    commit('changeLoading', { isLoading: true })
    return Messenger.findConversation({
      from: user,
      to: otherUser
    })
      .then(({ data }) => {
        commit('replaceItem', { item: data })
        commit('changeLoading', { isLoading: false })
        return data
      })
      .catch(error => onError(commit, { error }))
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/conversations/actions.js